import React from 'react';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import AppConfig from '../../config/app.json';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';

const styles = {
  root: {
    height: 64,
  }
}

const NonNavHeader = ({ rightNav }) => {
	return (
    <Box boxShadow={2}>
      <Grid
        container
        style={{align: "center"}}
      >
        <Container>
            <Box sx={{...styles.root}}>
              <Toolbar style={{ paddingLeft: "5px", paddingRight: "8px", }}>
                <img
                  src={AppConfig.logo_path}
                  width={35}
                  height={35}
                  alt="user_photo"
                />
                <div style={{display: "flex", flexDirection: "column", paddingLeft: "5px" }}>
                  <Typography variant="h4" style={{color: "#205A57", fontWeight: "bold",}}>
                    {AppConfig.product_name}
                  </Typography>
                    <a href="https://jeonsoft.com" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none" }}>
                      <Typography style={{ fontSize: "0.71rem", fontWeight: "bold" }}>
                        Powered by JeonSoft
                      </Typography>
                    </a>
                </div>
                <div style={{flex: 1}} />
                {rightNav}
              </Toolbar>
            </Box>
        </Container>
      </Grid>
    </Box>
  );
}

export default NonNavHeader;